import React, { useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "../../loading/spinner";
import UpperbarContext from "../../context/upperbar-context";
import AuthContext from "../../context/auth-context";
import { Fetchdata } from "../../hooks/getData";
import "react-toastify/dist/ReactToastify.css";
import "./attendanceReport.css";

export default function ManualAttendance() {
  const { User } = useContext(AuthContext);
  const { mode, appURL, customStyles } = useContext(UpperbarContext);

  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [year, setYear] = useState("2082");
  const [month, setMonth] = useState("01");
  const [branch, setBranch] = useState(User.BranchID || "1");
  const [chooseDepartment, setChooseDepartment] = useState("-1");
  const [chooseDesignation, setChooseDesignation] = useState("-1");
const [departmentList, setDepartmentList] = useState([]);
const [designationList, setDesignationList] = useState([]);

  useEffect(() => {
    deptList();
  }, []);

  const deptList = () => {
    const params = {
       AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: "-1",
      Flag: "S",
      DFlag:"DEPARTMENT",
      Type: "POST",
      FetchURL: `${appURL}api/admin/ref-values`,
    };


    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.Values ? result.Values : "";

        setDepartmentList(postResult);
      } else {
      }
    });
  };


    useEffect(() => {
    desigList();
  }, []);

  const desigList = () => {
    const params = {
       AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: "-1",
      Flag: "S",
      DepartID: chooseDepartment,
      DFlag:"DESIGNATION",
      Type: "POST",
      FetchURL: `${appURL}api/admin/ref-values`,
    };


    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.Values ? result.Values : "";

        setDesignationList(postResult);
      } else {
      }
    });
  };


   const handleChanges = (e) => {
    const target = e.target;
    const value = target.value;
    
    setChooseDepartment(value);
    setChooseDesignation("-1");
  };
  const handleDesignationChange = (e) => {
  const value = e.target.value;
  setChooseDesignation(value);
};

  const nepaliMonths = [
    { value: "01", label: "Baisakh" },
    { value: "02", label: "Jestha" },
    { value: "03", label: "Ashadh" },
    { value: "04", label: "Shrawan" },
    { value: "05", label: "Bhadra" },
    { value: "06", label: "Ashwin" },
    { value: "07", label: "Kartik" },
    { value: "08", label: "Mangsir" },
    { value: "09", label: "Poush" },
    { value: "10", label: "Magh" },
    { value: "11", label: "Falgun" },
    { value: "12", label: "Chaitra" },
  ];

  const years = ["2080", "2081", "2082"];

  useEffect(() => {
    fetchData();
  }, [year, month, branch,chooseDepartment,chooseDesignation]);

  const fetchData = async () => {
    setLoading(true);
    const response = await Fetchdata({
      ComID: User.ComID,
      AuthCode: User.AuthCode,
      UserID: User.UID,
      Month: `${year}/${month}`,
      BranchID: branch,
      DepartID:chooseDepartment,
      DesigID:chooseDesignation,
      Flag: "S",
      FetchURL: `${appURL}api/admin/manual-attendance`,
      Type: "POST",
    });

    if (response.StatusCode === 200) {
      setDataList(response.Values);
    } else {
      setDataList([]);
      toast.error("Failed to load data");
    }
    setLoading(false);
  };

  const handleInputChange = (e, row, field) => {
    const updatedList = dataList.map((item) =>
      item.UserID === row.UserID ? { ...item, [field]: e.target.value } : item
    );
    setDataList(updatedList);
  };

  const handleSave = async () => {
    const payload = dataList.map((item) => ({
      StaffID: item.UserID,
      PresentDays: item.PresentDays,
      AbsentDays: item.AbsentDays,
      OverTime: item.OTTime,
    }));

    const response = await Fetchdata({
      ComID: User.ComID,
      AuthCode: User.AuthCode,
      UserID: User.UID,
      Month: `${year}/${month}`,
      Flag: "i",
      Values: payload,
      FetchURL: `${appURL}api/admin/manual-attendance`,
      Type: "POST",
    });

    if (response.StatusCode === 200) {
      toast.success("Updated successfully");
    } else {
      toast.error("Update failed: " + response.Message);
    }
  };

  const columns = [
    {
      name: "S.N.",
       width: "70px",
      center: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Full Name",
      selector: (row) => row.FullName,
    },
    {
      name: "Present Days",
      center: true,
      cell: (row) => (
        <input
          type="number"
          value={row.PresentDays}
          onChange={(e) => handleInputChange(e, row, "PresentDays")}
          className="form-control form-control-sm"
        />
      ),
    },
    {
      name: "Absent Days",
      center: true,
      cell: (row) => (
        <input
          type="number"
          value={row.AbsentDays}
          onChange={(e) => handleInputChange(e, row, "AbsentDays")}
          className="form-control form-control-sm"
        />
      ),
    },
    {
      name: "Over Time",
      center: true,
      cell: (row) => (
        <input
          type="number"
          value={row.OTTime}
          onChange={(e) => handleInputChange(e, row, "OTTime")}
          className="form-control form-control-sm"
        />
      ),
    },
  ];

  return (
     <div className=" sumatten-wrapper  mt-3 ">
    <>
    <div>
      <ToastContainer />
      <div className="upper-dataTbl">
              <div className="uk-flex uk-flex-wrap uk-flex-between uk-flex-middle mb-3">
                <div className="uk-flex uk-flex-wrap">
                  <div className="me-2 mt-3">
                    <label className="d-block text-start dark-gray mb-1">
                      {mode === "en"
                        ? " Select Year"
                        : "इन्टरनेटको सक्रिय मार्ग चयन गर्नुहोस्"}
                    </label>
            <select
              class="form-select form-select-sm"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option disabled>Select Year</option>
              {years.map((yr) => (
                <option key={yr} value={yr}>
                  {yr}
                </option>
              ))}
            </select>
          </div>
          <div className="me-2 mt-3">
            <label className="d-block text-start dark-gray mb-1">
                      {mode === "en"
                        ? " Select Month"
                        : "इन्टरनेटको सक्रिय मार्ग चयन गर्नुहोस्"}
                    </label>
            <select
               class="form-select form-select-sm"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            >
              <option disabled>Select Month</option>
              {nepaliMonths.map((mn) => (
                <option key={mn.value} value={mn.value}>
                  {mn.label}
                </option>
              ))}
            </select>
          </div>
          <div className="me-2 mt-3">
            <label className="d-block text-start dark-gray mb-1">
                      {mode === "en"
                        ? " Select Branch"
                        : "इन्टरनेटको सक्रिय मार्ग चयन गर्नुहोस्"}
                    </label>
            <select
               class="form-select form-select-sm"
              value={branch}
              onChange={(e) => setBranch(e.target.value)}
            >
              <option disabled>Select Branch</option>
              <option value="1">Main Branch</option>
              <option value="2">Branch 2</option>
              <option value="3">Branch 3</option>
              {/* Extend based on actual branches */}
            </select>
          </div>

          <div className="me-2 mt-3">
                    <label className="d-block text-start dark-gray mb-1">
                      {mode === "en"
                        ? "Select Department"
                        : "विभाग चयन गर्नुहोस्"}
                    </label>
                    <select
                      style={{ fontSize: "11px" }}
                      name="snotifiaction"
                      value={chooseDepartment}
                      onChange={handleChanges}
                      className="form-select form-select-sm"
                    >
                      <option
                        value="0"
                        disabled
                        selected
                        style={{ fontSize: "11px" }}
                      >
                        {mode === "en"
                          ? "Select Department"
                          : "विभाग चयन गर्नुहोस्"}
                      </option>
                      <option value="-1">
                        {mode === "en" ? "Select All" : "सबै चयन गर्नुहोस्"}
                      </option>
                      {departmentList.map((item) => (
                        <option
                          key={item.DepartID}
                          value={item.DepartID}
                        >
                          {item.Department}
                        </option>
                      ))}
                    </select>
                  </div>


                   <div className="me-2 mt-3">
                    <label className="d-block text-start dark-gray mb-1">
                      {mode === "en"
                        ? "Select Designation"
                        : "विभाग चयन गर्नुहोस्"}
                    </label>
                    <select
                      style={{ fontSize: "11px" }}
                      name="snotifiaction"
                      value={chooseDesignation}
                      onChange={handleDesignationChange}
                      className="form-select form-select-sm"
                    >
                      <option
                        value="0"
                        disabled
                        selected
                        style={{ fontSize: "11px" }}
                      >
                        {mode === "en"
                          ? "Select Designation"
                          : "विभाग चयन गर्नुहोस्"}
                      </option>
                      <option value="-1">
                        {mode === "en" ? "Select All" : "सबै चयन गर्नुहोस्"}
                      </option>
                      {designationList.map((item) => (
                        <option
                          key={item.DesignID}
                          value={item.DesignID}
                        >
                          {item.Designation}
                        </option>
                      ))}
                    </select>
                  </div>


  </div>


     <div className="">
                  <div className="d-flex uk-flex-wrap uk-flex-middle uk-flex-right">
                    <div className="btn-addlnote mt-3">
                      <button
                        type="button"
                        class="btn btn-sm"
                        style={{
                          background: "var(--button-color)",
                          color: "white",
                        }}
                        onClick={handleSave}
                      >
                      
                        {mode === "en"
                          ? "Update"
                          : "उपस्थिति इन्टरनेटको मार्ग थप्नुहोस्"}
                      </button>
                    </div>
                  </div>
                </div>
 </div>
        </div>

        {loading ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={dataList}
            customStyles={customStyles}
            pagination
            responsive
            striped
              paginationRowsPerPageOptions={[10, 20, 50, 100]} // Customizable options
                    fixedHeaderScrollHeight="335px"
                    highlightOnHover
                    pointerOnHover
                    progressPending={loading}
                    dense
                    fixedHeader
          />
        )}
     
    
      </div>
    </>
    </div>
  );
}
